// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAPR56g9apkJIW0LV2UMt-G20FJ4rxvmDo",
  authDomain: "phone-book-app-d77d1.firebaseapp.com",
  projectId: "phone-book-app-d77d1",
  storageBucket: "phone-book-app-d77d1.appspot.com",
  messagingSenderId: "277317088323",
  appId: "1:277317088323:web:8ad94d6e9ee802387ed0f6",
  measurementId: "G-ZMQ5B2569V"
};

// Initialize Firebase
const fireDb =firebase.initializeApp(firebaseConfig);


export default fireDb.firebase.database().ref();